import { render, staticRenderFns } from "./TenantUsers.vue?vue&type=template&id=66308e1a&scoped=true"
import script from "./TenantUsers.vue?vue&type=script&lang=js"
export * from "./TenantUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66308e1a",
  null
  
)

export default component.exports